<template>
    <Card v-show="this.visible" style="">
        <template #content>
            <Fieldset :legend="$t('employee_data')" :toggleable="true" :collapsed="false">
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Name" class="col-4">{{ $t('emp_name') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Name" v-model="this.dataPdf.Employees.Name" type="text"
                                        :placeholder="$t('emp_name')" v-if="dataPdf" :disabled="true" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="NIK" class="col-4">{{ $t('emp_number') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="NIK" v-model="this.dataPdf.Employees.NIK" type="text"
                                        :placeholder="$t('emp_number')" :disabled="true" v-if="dataPdf" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Work_Begin_Date" class="col-4">{{ $t('workdate') }}</label>
                                <div class="col-8 md-8">
                                    <DatePicker tabindex="3" name="Work_Begin_Date"
                                        v-model="this.dataPdf.Employees.Work_Begin_Date" :showOnFocus="true"
                                        :placeholder="$t('workdate')" v-if="dataPdf" :disabled="true"
                                        dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                        style="width : 100%" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Grade_Code" class="col-4">{{ $t('grade') }}</label>
                                <div class="col-8 md-8">
                                    <CustomSelect class="p-inputtext-sm" v-model="this.dataPdf.Employees.Grade_Code"
                                        v-if="dataPdf" :filter="true" :url="this.$API_URL + 'list/grade_code'"
                                        :minLength="0" :disabled="true" :params="{}" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Current_Warning_Letter" class="col-4">{{ $t('warning_letter_period') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Current_Warning_Letter"
                                        v-model="this.dataPdf.Employees.Current_Warning_Letter" type="text"
                                        :placeholder="$t('warning_letter_period')" v-if="dataPdf" :disabled="true" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Name_Approval1" class="col-4">{{ $t('superior1') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Name_Approval1"
                                        :modelValue="Text_Approval1 || formatApproval(this.dataPdf.NIK_Approval1, this.dataPdf.Name_Approval1)"
                                        type="text" :placeholder="$t('superior1')" v-if="dataPdf" :disabled="true" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Company_Code" class="col-4">{{ $t('company') }}</label>
                                <div class="col-8 md-8">
                                    <CustomSelect class="p-inputtext-sm" v-model="this.dataPdf.Employees.Company_Code"
                                        v-if="dataPdf" :filter="true" :url="this.$API_URL + 'list/company_code'"
                                        :minLength="0" :disabled="true" :params="{}" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Unit_Code" class="col-4">{{ $t('unit') }}</label>
                                <div class="col-8 md-8">
                                    <CustomSelect class="p-inputtext-sm" v-model="this.dataPdf.Employees.Unit_Code"
                                        v-if="dataPdf" :filter="true" :url="this.$API_URL + 'list/unit_code'" :minLength="0"
                                        :disabled="true" :params="{}" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                            <!-- <div class="field grid">
                                <label for="Division_Code" class="col-4">{{ $t('division') }}</label>
                                <div class="col-8 md-8">
                                    <CustomSelect class="p-inputtext-sm" v-model="this.dataPdf.Employees.Division_Code"
                                        v-if="dataPdf" :filter="true" :url="this.$API_URL + 'list/division_code'"
                                        :minLength="0" :disabled="true" :params="{}" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Department_Code" class="col-4">{{ $t('department') }}</label>
                                <div class="col-8 md-8">
                                    <CustomSelect class="p-inputtext-sm" v-model="this.dataPdf.Employees.Department_Code"
                                        v-if="dataPdf" :filter="true" :url="this.$API_URL + 'list/department_code'"
                                        :minLength="0" :disabled="true" :params="{}" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div> -->
                            <!-- <div class="field grid">
                                <label for="Section_Code" class="col-4">{{ $t('section') }}</label>
                                <div class="col-8 md-8">
                                    <CustomSelect class="p-inputtext-sm" v-model="this.dataPdf.Employees.Section_Code"
                                        v-if="dataPdf" :filter="true" :url="this.$API_URL + 'list/section_code'"
                                        :minLength="0" :disabled="true" :params="{}" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div> -->
                            <div class="field grid">
                                <label for="Position" class="col-4">{{ $t('position') }}</label>
                                <div class="col-8 md-8">
                                    <CustomSelect class="p-inputtext-sm" v-model="this.dataPdf.Employees.Position_Code"
                                        v-if="dataPdf" :filter="true" :url="this.$API_URL + 'list/position_code'"
                                        :minLength="0" :disabled="true" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                            <!-- <div class="field grid" v-if="dataPdf && dataPdf.Employees.Source == 'HCM'">
                                <label for="Structure" class="col-4">{{ $t('org_unit') }}</label>
                                <div class="col-8 md-8">
                                    <CustomSelect class="p-inputtext-sm" v-model="this.dataPdf.Employees.Structure"
                                        v-if="dataPdf" :filter="true" :url="this.$API_URL + 'list/org_unit_desc'"
                                        :minLength="0" :disabled="true" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div> -->
                            <div class="field grid">
                                <label for="Structure" class="col-4">{{ $t('structure') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Structure" v-model="this.dataPdf.Employees.Structure" type="text"
                                        :placeholder="$t('structure')" v-if="dataPdf" :disabled="true" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Period_Year" class="col-4">{{ $t('appraisal_period') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Period_Year" v-model="this.dataPdf.Period_Year" type="text"
                                        :placeholder="$t('appraisal_period')" v-if="dataPdf" :disabled="true" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Name_Approval2" class="col-4">{{ $t('superior2') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Name_Approval2"
                                        :modelValue="Text_Approval2 || formatApproval(this.dataPdf.NIK_Approval2, this.dataPdf.Name_Approval2)"
                                        type="text" :placeholder="$t('superior2')" v-if="dataPdf" :disabled="true" />
                                    <Skeleton v-else-if="!dataPdf" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fieldset>
            <br />
            <Fieldset :legend="$t('appraisal_data')" :toggleable="true" :collapsed="false">
                <h6 style="font-weight: bold;" v-if="this.dataPdf.Fortable == 'MANAGERIAL'">SECTION II SELF-EVALUATION</h6>
                <template v-if="this.dataPdf.Fortable == 'MANAGERIAL'"
                    v-for="(sect, index) in [...new Set(this.dataPdf.Questions.filter(a => a.Col_Area.indexOf('Section') > -1))]"
                    v-bind:key="sect.Col_Area">
                    <p style="font-weight: bold;">{{ index + 1 }}. {{ this.$store.getters.getLanguage == 'id' ?
                        sect.Question_Ind :
                        sect.Question_Eng }}</p>
                    <CKEditor editorStyle="height: 100px" v-model="sect.Answer" @text-change="editDetail(sect)"
                        @input="editDetail(sect)" class="managerial" :readonly="!canEdit" /> <br>
                </template>
                <table>
                    <tbody>
                        <template v-for="(proc, index) in [...new Set(this.dataPdf.Procedures)]" v-bind:key="proc.Col_Area">
                            <tr style="background:#92cddc;">
                                <td style="font-weight: bold;width:3%"
                                    v-bind:colspan="this.dataPdf.Fortable == 'FIRSTLINE' && proc.Col_Area == 'A' ? 2 : 0"> {{
                                        proc.Col_Area }}</td>
                                <td v-bind:colspan="this.dataPdf.Fortable == 'FIRSTLINE' && proc.Col_Area == 'A' ? 3 : 4"
                                    style="font-weight: bold;width:87%"> {{ this.$store.getters.getLanguage == 'id'
                                        ?
                                        proc.Question_Ind : proc.Question_Eng }}</td>
                                <td style="font-weight: bold;width:10%;text-align: center !important;">{{ $t('rating') }}</td>
                            </tr>
                            <template
                                v-for="quest1 in [...new Set(this.dataPdf.Questions.filter(a => a.Col_Area.indexOf(proc.Col_Area) > -1 && a.Col_Area != 'Comment'))]"
                                v-bind:key="quest1.Col_Area" v-if="this.dataPdf.Fortable != 'FIRSTLINE'">
                                <tr style="background:#CCCCCC;">
                                    <td style="font-weight: bold;">
                                        {{ quest1.Point != 0 ? quest1.Col_Area.substring(1, 2) : '' }}
                                    </td>
                                    <td colspan="4" style="font-weight: bold;">
                                        {{ this.$store.getters.getLanguage == 'id' ? quest1.Question_Ind : quest1.Question_Eng
                                        }}
                                    </td>
                                    <td style="font-weight: bold;text-align: center;">
                                        {{ quest1.Point != 0 ? quest1.Point + '%' : '' }}
                                    </td>
                                </tr>
                                <template
                                    v-for="qtdet in [...new Set(this.dataPdf.Question_Details.filter(a => a.Question_Id == quest1.Id))]"
                                    v-bind:key="qtdet.Question_Id" v-if="quest1.Point == 0">
                                    <tr>
                                        <td></td>
                                        <td>
                                            <RadioButton :id="qtdet.Id" :name="quest1.Col_Area" v-model="quest1.Answer"
                                                :value="qtdet.Point.toString()" @change="editDetail(quest1, proc)"
                                                :disabled="!canEdit" />
                                        </td>
                                        <td colspan="3"> {{ this.$store.getters.getLanguage == 'id' ? qtdet.Question_Ind :
                                            qtdet.Question_Eng }}</td>
                                        <td style="text-align: center;"> {{ qtdet.Point }}</td>
                                    </tr>
                                </template>
                            </template>
                            <tr v-if="this.dataPdf.Fortable == 'FIRSTLINE' && proc.Col_Area == 'A'">
                                <td colspan="2"></td>
                                <td><b>{{ $t('objective') }}</b></td>
                                <td><b>{{ $t('achieve') }}</b></td>
                                <td><b>{{ $t('evaluate') }}</b></td>
                                <td></td>
                            </tr>
                            <template
                                v-for="(quest1, indexQ) in [...new Set(this.dataPdf.Questions.filter(a => a.Col_Area.indexOf(proc.Col_Area) > -1 && a.Col_Area != 'Comment'))]"
                                v-bind:key="quest1.Col_Area" v-if="this.dataPdf.Fortable == 'FIRSTLINE'">
                                <tr style="background:#CCCCCC;" v-if="quest1.Col_Area.substring(2, 3) == ''">
                                    <td style="font-weight: bold;" colspan="2">
                                        {{ quest1.Point != 0 ? quest1.Col_Area.substring(1, 2) : ''
                                        }}
                                    </td>
                                    <td colspan="3" style="font-weight: bold;">
                                        {{ this.$store.getters.getLanguage == 'id' ? quest1.Question_Ind : quest1.Question_Eng
                                        }}
                                    </td>
                                    <td style="font-weight: bold;text-align: center;">
                                        {{ quest1.Point != 0 ? quest1.Point + '%' : '' }}
                                    </td>
                                </tr>
                                <template v-else-if="quest1.Col_Area.substring(2, 3) != '' && proc.Col_Area == 'A'">
                                    <tr v-if="indexQ == 1 || indexQ == 6 || indexQ == 11">
                                        <td colspan="2"></td>
                                        <template v-for="qfirst in [...new Set(this.dataPdf.Questions
                                            .filter(a => a.Col_Area.indexOf(proc.Col_Area + quest1.Col_Area.substring(1, 2)) > -1 &&
                                                a.Col_Area != proc.Col_Area + quest1.Col_Area.substring(1, 2)))]"
                                            v-bind:key="qfirst.Col_Area">
                                            <td v-if="qfirst.Question_Eng != 'Point'">
                                                <CKEditor editorStyle="height: 100px" v-model="qfirst.Answer" class="firstline"
                                                    @text-change="editDetail(qfirst, undefined, $event, 'change')"
                                                    @input="editDetail(qfirst, undefined, $event, 'input')"
                                                    :readonly="!canEdit" />
                                            </td>
                                            <td v-else style="text-align: center;">
                                                <Dropdown v-model="qfirst.Answer" :options="points" optionLabel="name"
                                                    optionValue="code" :placeholder="$t('point')"
                                                    @change="editDetail(qfirst, proc)" :readonly="!canEdit" />
                                            </td>
                                        </template>
                                    </tr>
                                </template>
                                <template
                                    v-for="qtdet in [...new Set(this.dataPdf.Question_Details.filter(a => a.Question_Id == quest1.Id))]"
                                    v-bind:key="qtdet.Question_Id" v-if="quest1.Point == 0">
                                    <tr>
                                        <td></td>
                                        <td>
                                            <RadioButton :id="qtdet.Id" :name="quest1.Col_Area" v-model="quest1.Answer"
                                                :value="qtdet.Point.toString()" @change="editDetail(quest1, proc)"
                                                :disabled="!canEdit" />
                                        </td>
                                        <td colspan="3"> {{ this.$store.getters.getLanguage == 'id' ? qtdet.Question_Ind :
                                            qtdet.Question_Eng }}</td>
                                        <td style="text-align: center;"> {{ qtdet.Point }}</td>
                                    </tr>
                                </template>
                            </template>
                            <tr>
                                <td colspan="5" style="text-align: right;">Sub-Total Score ({{ proc.Col_Area }}) </td>
                                <td style="text-align:right;">
                                    <input type="text" style="width:50px;background:#92cddc;text-align:right;"
                                        v-model="proc.Sub_Score" :readonly="true"> %
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5" style="text-align: right;">{{ $t('pembobotan') }} ({{ proc.Point }}%) </td>
                                <td style="text-align: right;">
                                    <input type="text" style="width:50px;background:#92cddc;text-align:right;"
                                        v-model="proc.Sub_Rating" :readonly="true"> %
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            </tr>
                        </template>
                        <template v-for="qtcom in [...new Set(this.dataPdf.Questions.filter(a => a.Col_Area == 'Comment'))]"
                            v-bind:key="qtcom.Col_Area" v-if="this.dataPdf">
                            <tr>
                                <td colspan="6">
                                    <p>
                                        {{ $t('comment_review') }}</p>
                                    <CKEditor editorStyle="height: 100px" v-model="qtcom.Answer" class="managerial"
                                        @text-change="editDetail(qtcom)" @input="editDetail(qtcom)" :readonly="!canEdit" />
                                </td>
                            </tr>
                        </template>
                        <tr>
                            <td colspan="5" style="text-align: right;">
                                TOTAL SCORE {{ $t('pembobotan') }} [({{ !this.dataPdf.Procedures ? '' :
                                    this.dataPdf.Procedures.map(a =>
                                        a.Col_Area).join(",") }})]
                            </td>
                            <td style="text-align: right;">
                                <input type="text" v-model="this.dataPdf.Score" :readonly="true"
                                    style="width:50px;background:#92cddc;text-align:right;">% <br>
                                <input type="text" v-model="this.dataPdf.Rate" :readonly="true"
                                    style="width:50px;background:#92cddc;text-align:right;">&nbsp;&nbsp;&nbsp;
                            </td>
                        </tr>
                        <tr v-if="this.dataPdf.Fortable == 'MANAGERIAL' && this.dataPdf.mode == this.$FORM_MODE_EDIT"
                            v-for="(summ, index) in [...new Set(this.dataPdf.Questions.filter(a => a.Col_Area.indexOf('Summary') > -1))]"
                            v-bind:key="summ.Col_Area">
                            <td colspan="6">
                                <p>{{ this.$store.getters.getLanguage == 'id' ?
                                    summ.Question_Ind :
                                    summ.Question_Eng }}</p>
                                <CKEditor editorStyle="height: 100px" v-model="summ.Answer" @text-change="editDetail(summ)"
                                    @input="editDetail(summ)" class="managerial" :readonly="!canEdit" />
                                <br>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="this.Error_Message != ''">
                    <ul>
                        <Message severity="warn" :closable="false" v-html="this.Error_Message">
                        </Message>
                    </ul>
                </div>
                <br />
                <div class="grid"
                    v-if="this.dataPdf && !this.superior && !this.head && !this.functional && this.dataPdf.Employees.NIK != this.$store.getters.getUsername &&
                        (this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_UNIT)">
                    <div class="col-6">
                        <div class="field grid">
                            <label for="Action_Role" class="col-4 md-8" style="padding-left:20px;">{{ $t('action_role')
                            }}</label>
                            <div class="col-8 md-8">
                                <Dropdown v-model="this.dataPdf.Action_Role" :options="listActionRole" optionLabel="value"
                                    optionValue="value" :placeholder="$t('action_role')" :disabled="!canEdit"
                                    @change="this.ChangeRole()" style="width:100%" />
                            </div>
                        </div>
                    </div>
                </div>
            </Fieldset>
            <br />
            <Fieldset :legend="$t('promotion_data')" :toggleable="true" :collapsed="false">
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-12">
                            <div class="field grid">
                                <label for="Promotion" class="col-10"><b>{{ $t('disclaimer_promotion1') }}<br />{{
                                    $t('disclaimer_promotion2') }}</b></label>
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="field grid">
                                <label for="Promotion" class="col-10">{{ $t('promotion_request') }}</label>
                                <Checkbox name="Promotion" v-model="this.dataPdf.Promotion" :binary="true"
                                    :disabled="!this.superior && !this.head && !this.force_Checkbox_Promot" />
                            </div>
                        </div>
                        <div class="col-10">
                            <div class="field grid">
                                <label for="Remark" class="col-3">{{ $t('remark') }} (Superior)<span
                                        style="color: red;">*</span></label>
                                <div class="col-9">
                                    <Textarea name="Remark" v-model="this.dataPdf.S_Remark" type="text"
                                        :placeholder="$t('remark_1000')"
                                        :disabled="!this.superior && !this.force_Remark_Superior" :autoResize="true"
                                        rows="3" cols="30" maxlength="1000" />
                                </div>
                            </div>
                            <div class="field grid"
                                v-show="this.head || this.fromMenu == 'AppraisalIndexAllIndex' || this.force_Remark_Head">
                                <label for="Remark" class="col-3">{{ $t('remark') }} (Head)<span
                                        style="color: red;">*</span></label>
                                <div class="col-9">
                                    <Textarea name="Remark" v-model="this.dataPdf.H_Remark" type="text"
                                        :placeholder="$t('remark_1000')" :disabled="!this.head && !this.force_Remark_Head"
                                        :autoResize="true" rows="3" cols="30" maxlength="1000" />
                                </div>
                            </div>
                            <div class="field grid"
                                v-show="this.fromMenu == 'AppraisalIndexAllIndex' || this.force_Remark_OU_Head">
                                <label for="Remark" class="col-3">{{ $t('remark') }} (committee)<span
                                        style="color: red;">*</span></label>
                                <div class="col-9">
                                    <Textarea name="Remark" v-model="this.dataPdf.OH_Remark" type="text"
                                        :placeholder="$t('remark_1000')"
                                        :disabled="!this.ou_head && !this.force_Remark_OU_Head" :autoResize="true" rows="3"
                                        cols="30" maxlength="1000" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label class="col-3"></label>
                                <hr class="col-9"
                                    style="margin-bottom: -5px;height: 3px;background-color: black;color:black;">
                            </div>
                            <div class="field grid">
                                <label class="col-3"></label>
                                <label class="col-9"
                                    style="justify-content: center;color:cornflowerblue;margin-bottom: -5px;font-style: italic;">
                                    {{ $t('positionminKP') }}
                                </label>
                            </div>
                            <div class="field grid" style="text-align: center;">
                                <label for="LengthWork" class="col-3">{{ $t('lengthWork') }}</label>
                                <div class="col-9">
                                    <InputText name="LengthWork" v-model="this.dataPdf.LengthWork" type="text"
                                        style="text-align: center;font-weight: bold;" :placeholder="$t('lengthWork')"
                                        :disabled="true" />
                                    <br>
                                    <label style="color:cornflowerblue;font-style: italic;">{{ $t('min2year') }}</label>
                                </div>
                            </div>
                            <div class="field grid" style="text-align: center;">
                                <label for="LengthGrade" class="col-3">{{ $t('lengthGrade') }}</label>
                                <div class="col-9">
                                    <InputText name="LengthGrade" v-model="this.dataPdf.LengthGrade" type="text"
                                        style="text-align: center;font-weight: bold;" :placeholder="$t('lengthGrade')"
                                        :disabled="true" />
                                    <br>
                                    <label style="color:cornflowerblue;font-style: italic;">{{ $t('min2year') }}</label>
                                </div>
                            </div>
                            <div class="field grid" style="text-align: center;">
                                <label for="SP" class="col-3">{{ $t('warning_letter_period') }}</label>
                                <div class="col-9">
                                    <InputText name="SP" v-model="this.dataPdf.SP" type="text"
                                        style="text-align: center;font-weight: bold;" placeholder="SP" :disabled="true" />
                                    <br>
                                    <label style="color:cornflowerblue;font-style: italic;">{{ $t('spminKP') }}</label>
                                </div>
                            </div>
                            <div class="field grid" style="text-align: center;">
                                <label for="Education" class="col-3">{{ $t('education') }}</label>
                                <div class="col-9">
                                    <InputText name="Education" v-model="this.dataPdf.Education" type="text"
                                        style="text-align: center;font-weight: bold;" :placeholder="$t('education')"
                                        :disabled="true" />
                                    <br>
                                    <label style="color:cornflowerblue;font-style: italic;">{{ $t('educationminKP')
                                    }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fieldset>
        </template>
    </Card>
</template>


<script>
export default {
    name: "Editor",
    props: {
        isVisible: {
            type: Boolean,
            default: true,
        },
        dataPdf: {
            type: Object,
            default: null,
        },
        Error_Message: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            indexName: "AppraisalIndex",
            url: this.$API_URL + "appraisal/",
            urlQuestion: this.$API_URL + "appraisal/getquestion/",
            mode: "",
            submitted: false,
            id: 0,
            formEditable: true,
            visible: false,
            NIK_Approval1: "",
            NIK_Approval2: "",
            Text_Approval1: "",
            Text_Approval2: "",
            NIK_Functional: "",
            Email_Approval1: "",
            Email_Approval2: "",
            Email_Functional: "",
            fromTab: "",
            fromMenu: "",
            force_Checkbox_Promot: false,
            force_Remark_Superior: false,
            force_Remark_Head: false,
            force_Remark_OU_Head: false,
            points: [
                { name: "10", code: "10" },
                { name: "20", code: "20" },
                { name: "30", code: "30" },
                { name: "40", code: "40" },
                { name: "50", code: "50" }
            ]
        }
    },
    watch: {
        isVisible(newVal) {
            this.visible = newVal;
        },
        'dataPdf.NIK_Approval1': {
            immediate: true,
            handler(nik) {
                this.loadApprovalText(nik, 1);
            }
        },
        'dataPdf.NIK_Approval2': {
            immediate: true,
            handler(nik) {
                this.loadApprovalText(nik, 2);
            }
        }
    },
    methods: {
        loadApprovalText(nik, idx) {
            var key = idx == 1 ? 'Text_Approval1' : 'Text_Approval2';
            if (!nik) {
                this[key] = "";
                return;
            }
            this.$axios.get(this.$API_URL + 'list/employee_no', { params: { q: nik, init: true, excempId: "0" } })
                .then((response) => {
                    var items = response.data && response.data.items;
                    if (items && items.length > 0 && this.dataPdf && (idx == 1 ? this.dataPdf.NIK_Approval1 : this.dataPdf.NIK_Approval2) == nik)
                        this[key] = items[0].text;
                })
                .catch(() => { });
        },
        formatApproval(nik, name) {
            if (!nik) return name || "";
            return "[" + nik + "] " + (name || "");
        },
        getData() {
            this.NIK_Approval1 = this.dataPdf.NIK_Approval1;
            this.NIK_Approval2 = this.dataPdf.NIK_Approval2;
            this.NIK_Functional = this.dataPdf.NIK_Functional;
            this.Email_Approval1 = this.dataPdf.Email_Approval1;
            this.Email_Approval2 = this.dataPdf.Email_Approval2;
            this.Email_Functional = this.dataPdf.Email_Functional;

            var self = this;
            if (this.dataPdf.mode == this.$FORM_MODE_CREATE) {
                this.$axios.get(this.urlQuestion + this.dataPdf.Employee_Id + "/" + this.dataPdf.mode)
                    .then((response) => {
                        if (response.data.success) {
                            this.dataPdf.NIK_Approval1 = this.NIK_Approval1;
                            this.dataPdf.NIK_Approval2 = this.NIK_Approval2;
                            this.dataPdf.Email_Approval1 = this.Email_Approval1;
                            this.dataPdf.Email_Approval2 = this.Email_Approval2;

                            this.dataPdf.mode = response.data.data.header.mode;
                            this.dataPdf.Period_Year = response.data.data.header.Period_Year;
                            this.dataPdf.Employee_Id = response.data.data.header.Employee_Id;
                            this.dataPdf.Fortable = response.data.data.header.Fortable;

                            this.dataPdf.Details = response.data.data.header.Details;
                            this.dataPdf.Employees = response.data.data.header.Employees;
                            this.dataPdf.Procedures = response.data.data.header.Procedures;
                            this.dataPdf.Questions = response.data.data.header.Questions;
                            this.dataPdf.Question_Details = response.data.data.header.Question_Details;

                            this.dataPdf.SP = response.data.data.header.SP;
                            this.dataPdf.Education = response.data.data.header.Education;
                            this.dataPdf.LengthGrade = response.data.data.header.LengthGrade;
                            this.dataPdf.LengthWork = response.data.data.header.LengthWork;
                        }
                    })
                    .catch(function (error) {
                        this.showError('Error Get Data Question', error);
                    })
            }

            this.dataPdf.Score = 0;
            this.dataPdf.Rate = "";

            this.dataPdf.Procedures.forEach((e, index) => {
                const subScore = this.subScore(e);
                const subRating = ((subScore * e.Point) / 100).toFixed(0);

                e.Sub_Score = subScore;
                e.Sub_Rating = subRating;
                this.dataPdf.Score += parseFloat(subRating);
                this.getTotalRating();
            });

            if (!this.superior && !this.head && !this.functional && this.dataPdf.Employees.NIK != this.$store.getters.getUsername &&
                (this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO || this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_UNIT || this.$store.getters.getAccount == this.$ACCOUNT.OU_HEAD)) {
                if (this.dataPdf.mode == this.$FORM_MODE_CREATE)
                    this.dataPdf.Action_Role = this.$Action_Role.User;
                else if (this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO)
                    this.dataPdf.Action_Role = this.$Action_Role.Admin_HO;
                else if (this.$store.getters.getAccount == this.$ACCOUNT.OU_HEAD)
                    this.dataPdf.Action_Role = this.$Action_Role.OU_Head;
                else
                    this.dataPdf.Action_Role = this.$Action_Role.Admin_Unit;
            }

            this.ChangeRole();
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            this.showAppraisal = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        editDetail(sect, proc, e, from) {
            if (sect) {
                if (this.dataPdf.mode == this.$FORM_MODE_CREATE) {
                    sect.mode = this.$FORM_MODE_CREATE;
                }
                else {
                    sect.mode = this.$FORM_MODE_EDIT;
                }

                if (this.dataPdf.Fortable == "FIRSTLINE") {
                    if (from == "input") {
                        sect.Answer = e.target.innerHTML;
                    }
                    else if (from == "change") {
                        sect.Answer = e.htmlValue;
                    }
                    else {
                        this.dataPdf.Questions.filter(a => a.Col_Area == sect.Col_Area.substring(0, 2) && a.Point != 0)[0].mode = sect.mode;
                        this.dataPdf.Questions.filter(a => a.Col_Area == sect.Col_Area.substring(0, 2) && a.Point != 0)[0].Answer = sect.Answer;
                    }
                }
                else if (sect.Col_Area.indexOf('Section') > -1 || sect.Col_Area.indexOf('Comment') > -1 || sect.Col_Area.indexOf('Remark') > -1) {
                }
                else {
                    this.dataPdf.Questions.filter(a => a.Col_Area == sect.Col_Area && a.Point != 0)[0].mode = sect.mode;
                    this.dataPdf.Questions.filter(a => a.Col_Area == sect.Col_Area && a.Point != 0)[0].Answer = sect.Answer;
                }
            }

            if (proc != undefined) {
                const subScore = this.subScore(proc);

                this.dataPdf.Procedures.filter(a => a == proc)[0].Sub_Score = subScore.toString();
                this.dataPdf.Procedures.filter(a => a == proc)[0].Sub_Rating = ((subScore * proc.Point) / 100).toFixed(0).toString();

                const dataArray = this.dataPdf.Procedures.map(a => parseFloat(a.Sub_Rating));
                const reducer = (accumulator, curr) => accumulator + curr;
                this.dataPdf.Score = dataArray.reduce(reducer).toFixed(0);
                this.getTotalRating();
            }
        },
        subScore(proc) {
            if (proc) {
                const dataArray = this.dataPdf.Questions
                    .filter(a => a.Col_Area.indexOf(proc.Col_Area) > -1 && a.Point != 0)
                    .map(a => ((((a.Point / 100) / (proc.Point / 100) * a.Answer)) * 100) / 50)

                if (dataArray.length <= 0) return 0;

                const reducer = (accumulator, curr) => accumulator + curr;
                return dataArray.reduce(reducer).toFixed(0);
            }
            else {
                return 0;
            }
        },
        getTotalRating() {
            var listCriteria = this.$store.getters.getCriteria.filter(a => a.Period_Year == this.dataPdf.Period_Year);
            listCriteria.some((e, index) => {
                if (this.dataPdf.Score > e.Range)
                {
                    this.dataPdf.Rate = e.Grade;
                    return true;
                }
            });
        },
        ChangeRole() {
            if (this.dataPdf.Action_Role == this.$Action_Role.Superior) {
                this.force_Checkbox_Promot = true;
                this.force_Remark_Superior = true;
                this.force_Remark_Head = false;
                this.force_Remark_OU_Head = false;
            }
            else if (this.dataPdf.Action_Role == this.$Action_Role.Head) {
                this.force_Checkbox_Promot = true;
                this.force_Remark_Head = true;
                this.force_Remark_Superior = false;
                this.force_Remark_OU_Head = false;
            }
            else if (this.dataPdf.Action_Role == this.$Action_Role.OU_Head) {
                this.force_Checkbox_Promot = true;
                this.force_Remark_Head = false;
                this.force_Remark_Superior = false;
                this.force_Remark_OU_Head = true;
            }
            else {
                this.force_Checkbox_Promot = false;
                this.force_Remark_Superior = false;
                this.force_Remark_Head = false;
                this.force_Remark_OU_Head = false;
            }
        }
    },
    created() {
        this.fromTab = this.$route.query.fromTab;
        this.fromMenu = this.$route.query.fromMenu;
        this.getData();
    },
    mounted() {
        this.visible = this.isVisible
    },
    computed: {
        years() {
            let years = [];

            for (var i = new Date().getFullYear(); i <= new Date().getFullYear() + 20; i++) {
                years.push({ value: i.toString() })
            }
            return years;
        },
        canEdit() {
            return this.dataPdf.mode == this.$FORM_MODE_CREATE || this.dataPdf.mode == this.$FORM_MODE_EDIT;
        },
        superior() {
            return ((this.fromTab == 0 || this.fromTab == 1) && this.NIK_Approval1 == this.$store.getters.getUsername) || (this.NIK_Approval1 == this.$store.getters.getUsername && this.dataPdf.mode == this.$FORM_MODE_CREATE);
        },
        head() {
            return (this.fromTab == 2 && this.NIK_Approval2 == this.$store.getters.getUsername) || (this.NIK_Approval2 == this.$store.getters.getUsername && this.dataPdf.mode == this.$FORM_MODE_CREATE);
        },
        ou_head() {
            return (this.fromMenu == 'AppraisalIndexAllIndex' && this.$store.getters.getAccount == this.$ACCOUNT.OU_HEAD && this.dataPdf.mode == this.$FORM_MODE_EDIT);
        },
        functional() {
            return ((this.fromTab == 1 || this.fromTab == 2) && this.NIK_Functional == this.$store.getters.getUsername);
        },        
        listActionRole() {
            let listRole = [];

            if (this.dataPdf.H_Can_Edit) {
                listRole.push({ value: this.$Action_Role.Head });

                if ((this.dataPdf.Functional_Layer == 'HEAD SUPERIOR' || this.dataPdf.F_Can_Edit) && this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO) {
                    listRole.push({ value: this.$Action_Role.Functional });
                }
            }
            else if (this.dataPdf.S_Can_Edit) {
                listRole.push({ value: this.$Action_Role.Superior });

                if ((this.dataPdf.Functional_Layer == 'SUPERIOR' || this.dataPdf.F_Can_Edit) && this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO) {
                    listRole.push({ value: this.$Action_Role.Functional });
                }                

                listRole.push({ value: this.$Action_Role.Head });
            }
            else if (!this.dataPdf.K_Can_Edit) {
                listRole.push({ value: this.$Action_Role.User });
                listRole.push({ value: this.$Action_Role.Superior });

                if ((this.dataPdf.Functional_Layer == 'SUPERIOR' || this.dataPdf.F_Can_Edit) && this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO) {
                    listRole.push({ value: this.$Action_Role.Functional });
                }                

                listRole.push({ value: this.$Action_Role.Head });

                if ((this.dataPdf.Functional_Layer == 'HEAD SUPERIOR' || this.dataPdf.F_Can_Edit) && this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO) {
                    listRole.push({ value: this.$Action_Role.Functional });
                }                
            }

            if (this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_UNIT)
                listRole.push({ value: this.$Action_Role.Admin_Unit });

            if (this.$store.getters.getAccount == this.$ACCOUNT.OU_HEAD)
                listRole.push({ value: this.$Action_Role.OU_Head });

            if (this.$store.getters.getAccount == this.$ACCOUNT.ADMIN_HO) {
                listRole.push({ value: this.$Action_Role.OU_Head });
                listRole.push({ value: this.$Action_Role.Admin_Unit });
                listRole.push({ value: this.$Action_Role.Admin_HO });
            }

            return listRole;
        }
    }
}
</script>

<style scoped>
p {
    padding: 5px;
}

.p-card-content {
    padding: 0px !important;
}

.firstline {
    width: 270px !important;
}

.managerial {
    width: 600px !important;
}

table,
th,
td {
    border: 1px solid #ddd;
    border-collapse: collapse;
    text-align: left;
    font-family: Arial, Helvetica, sans-serif;
    padding: 5px;
}
</style>